import axios from 'axios';

const BASE_URL = 'http://localhost:5001/api/attended-conferences';

export const attendedConferencesService = {
  async list(userId) {
    if (!userId) {
      throw new Error('userId est requis');
    }
    const response = await axios.get(`${BASE_URL}?userId=${encodeURIComponent(userId)}`);
    return response.data;
  },

  async setAttendance(userId, conferenceId, attending) {
    const response = await axios.post(BASE_URL, {
      userId,
      conferenceId,
      attending
    });
    return response.data;
  }
};

export default attendedConferencesService;
